export const firebaseConfig = {
    apiKey: "AIzaSyC6NQgwckIiz7L5S7EVLHidsO8IByB3y_E",
    authDomain: "sportplatform-b5318.firebaseapp.com",
    projectId: "sportplatform-b5318",
    storageBucket: "sportplatform-b5318.firebasestorage.app",
    messagingSenderId: "607279059338",
    appId: "1:607279059338:web:23cf771c199457fdcb3873",
    measurementId: "G-N93CDPCXM5"
};